import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { selectUrl } from '../../../store/router/router.state';
import { AsyncPipe } from '@angular/common';
import { RouterLink, RouterOutlet } from '@angular/router';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';

@Component({
    selector: 'app-addresses-page',
    templateUrl: './addresses-page.component.html',
    styleUrls: ['./addresses-page.component.scss'],
    imports: [MatTabNav, MatTabLink, RouterLink, MatTabNavPanel, RouterOutlet, AsyncPipe]
})
export class AddressesPageComponent implements OnInit {

    constructor(private store: Store<AppState>) {
    }

    public url$ = this.store.select(selectUrl);

    ngOnInit(): void {
    }

}
